import React, { useState, useEffect } from "react";
import "../Goldpage/goldify.css";
import { useLocation, useNavigate } from "react-router-dom";
import BuySell from "../../components/BuySell";
import Products from "../products/Products";
import { useDispatch, useSelector } from "react-redux";
import { getGoldApi } from "../../redux/features/goldSlice";
import { portfolioApi } from "../../redux/features/portfolio/portfolioSlice";
import axiosInstance from "../../utils/axiosInstance";
import Loader from "../../components/Loader";
import { mmtcGoldApi } from "../../redux/features/mmtc/goldSlice";
import { motion } from "framer-motion";
import BuySellMmtc from "../../components/BuySellMmtc";
import { toast } from "react-toastify";
import CustomGoldAndSilverSip from "../customGoldAndSilverSip/CustomGoldAndSilverSip";

const Silvify = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAmount, amount: passedAmount } = location.state || {};

  const pathname = location.pathname;
  const sections = ["buy", "sell", "delivery", "sip"];

  const section = sections.find((section) => pathname.includes(section)) || "";

  const [activeButton, setActiveButton] = useState("Augmont");
  const [value, setValue] = React.useState("buy");

  useEffect(() => {
    dispatch(portfolioApi());
  }, [dispatch]);

  useEffect(() => {
    if (activeButton === "Augmont") {
      dispatch(getGoldApi());
    } else {
      const payload = {
        currencyPair: "XAG/INR",
        type: value === "buy" ? "BUY" : "SELL",
      };
      dispatch(mmtcGoldApi(payload));
    }
  }, [dispatch, activeButton, value]);

  const callQuantityAPI = async (
    rupeeValue,
    gramValue,
    status,
    transactionType
  ) => {
    try {
      const URL =
        transactionType === "silverBuy"
          ? "/augmont/get-quote-buy"
          : "/augmont/get-quote-sell";

      const pageLink =
        transactionType === "silverBuy"
          ? "/dashboard/silver-buy-summary"
          : "/dashboard/silver-sell-summary";
      // : "/dashboard/silversellsummary";

      const requestBody = {
        metalType: "silver",
        ...(status.isAmount ? { amount: rupeeValue } : { quantity: gramValue }),
      };

      const response = await axiosInstance.post(URL, requestBody);

      navigate(pageLink, {
        state: {
          key: "augmont",
          data: response.data,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error connecting to API", error);
    }
  };

  const mmtcBuyApi = async (
    rupeeValue,
    gramValue,
    isRupeeSelected,
    transactionType
  ) => {
    try {
      const pageLink =
        transactionType === "silverBuy"
          ? "/dashboard/silver-buy-summary"
          : "/dashboard/silver-sell-summary";

      const payload = {
        currencyPair: "XAG/INR",
        value: isRupeeSelected ? rupeeValue : gramValue,
        type: isRupeeSelected ? "A" : "Q",
      };

      const URL = `/customTrade/${
        transactionType === "goldSell" || transactionType === "silverSell"
          ? "sell"
          : "buy"
      }`;

      const response = await axiosInstance.post(URL, payload);

      if (!response.data.error) {
        navigate(pageLink, {
          state: {
            key: "mmtc",
            data: response.data,
          },
        });
      } else {
        toast.error("ERROR IN MMTC BUY API");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const {
    data: portApiRes,
    errors,
    loading: portApiLoading,
  } = useSelector((state) => state.portfolioSlice);

  // console.log("portfolio api response============>>>>>>>>>>", portApiRes);

  const {
    data: augmontData,
    error: augmontError,
    loading: augmontLoading,
  } = useSelector((state) => state.goldSlice);

  const { data, error, loading } = useSelector((state) => state.mmtcGoldSlice);

  // framer motion==================

  const variants = {
    initial: (direction) => ({
      x: direction === "left" ? "-20%" : "20%", // Reduced distance from 100% to 40%
      opacity: 0,
    }),
    animate: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.4, ease: "easeInOut" }, // Slowed down from 0.4s to 0.6s
    },
    exit: (direction) => ({
      x: direction === "left" ? "20%" : "-20%", // Reduced exit distance
      opacity: 0,
      transition: { duration: 0.4, ease: "easeInOut" },
    }),
  };

  const getDirection = (prev, current) => {
    const order = ["buy", "sell", "delivery"];
    return order.indexOf(current) > order.indexOf(prev) ? "right" : "left";
  };

  const [prevValue, setPrevValue] = React.useState(value);

  useEffect(() => {
    setPrevValue(value);
  }, [value]);

  useEffect(() => {
    if (activeButton === "MMTC" && value === "delivery") {
      setValue("buy"); // Switch to "Buy" if on "Delivery"
    }
  }, [activeButton, value]);

  const [activeTab, setActiveTab] = useState("oneTime");

  return (
    <div style={{ position: "relative" }}>
      <div className="switch_btn_container">
        {/* BUY & SELL==============  */}
        <div className="toggle-container">
          <div className="toggle-wrapper">
            <div
              className="slider"
              style={{
                left: location.pathname.includes("sip")
                  ? "0%"
                  : location.pathname.includes("buy")
                  ? "0%"
                  : location.pathname.includes("sell")
                  ? "33.33%"
                  : location.pathname.includes("delivery")
                  ? "66.66%"
                  : "0%",
                width: location.pathname.includes("sip") ? "33.33%" : "33.33%",
              }}
            ></div>
            {[
              {
                label: "Buy",
                value: "buy",
                link: "/dashboard/silver/buy",
              },
              {
                label: "Sell",
                value: "sell",
                link: "/dashboard/silver/sell",
              },
              {
                label: "Delivery",
                value: "delivery",
                link: "/dashboard/silver/delivery",
              },
            ].map((btn) => (
              <button
                key={btn.value}
                className={`toggle-button ${
                  location.pathname.includes(btn.value) ||
                  (location.pathname.includes("sip") && btn.value === "buy")
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setValue(btn.value);
                  navigate(btn.link);
                }}
                style={{ flex: 1 }} // Equal width for all buttons
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
        {/* SIP=============  */}
        {!location.pathname.includes("sell") &&
          !location.pathname.includes("delivery") && (
            <div className="toggle-container sip-tab-container">
              <div className="toggle-wrapper">
                <div
                  className="slider"
                  style={{
                    left: location.pathname.includes("sip") ? "50%" : "0%",
                    width: `${100 / 2}%`,
                  }}
                ></div>
                {[
                  {
                    label: "One Time",
                    value: "oneTime",
                    link: "/dashboard/silver/buy",
                    active: !location.pathname.includes("sip"),
                  },
                  {
                    label: "Monthly SIP",
                    value: "monthlySip",
                    link: "/dashboard/silver/sip",
                    active: location.pathname.includes("sip"),
                  },
                ].map((btn) => (
                  <button
                    key={btn.value}
                    className={`toggle-button ${btn.active ? "active" : ""}`}
                    onClick={() => {
                      navigate(btn.link);
                      setActiveTab(btn.value);
                    }}
                  >
                    {btn.label}
                  </button>
                ))}
              </div>
            </div>
          )}
      </div>

      {section === "sip" ? (
        <CustomGoldAndSilverSip />
      ) : (
        <motion.div
          key={section}
          custom={getDirection(prevValue, value)}
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          style={{ width: "100%" }}
        >
          {!portApiLoading && (augmontData || data) ? (
            section === "buy" ? (
              activeButton === "Augmont" ? (
                <BuySell
                  metalType="SILVER"
                  // goldApi={goldApi}
                  transactionType="silverBuy"
                  goldApiData={augmontData}
                  portfolioApiData={portApiRes}
                  callQuantityAPI={callQuantityAPI}
                  isAmount={isAmount}
                  userAmt={passedAmount}
                />
              ) : (
                <BuySellMmtc
                  livePrice={data}
                  metalType="SILVER"
                  transactionType="silverBuy"
                  portfolioApiData={portApiRes}
                  mmtcBuyApi={mmtcBuyApi}
                  userAmt={passedAmount}
                />
              )
            ) : section === "sell" ? (
              activeButton === "Augmont" ? (
                <BuySell
                  metalType="SILVER"
                  // goldApi={goldApi}
                  transactionType="silverSell"
                  goldApiData={augmontData}
                  portfolioApiData={portApiRes}
                  callQuantityAPI={callQuantityAPI}
                />
              ) : (
                <BuySellMmtc
                  livePrice={data}
                  metalType="SILVER"
                  transactionType="silverSell"
                  portfolioApiData={portApiRes}
                  mmtcBuyApi={mmtcBuyApi}
                  userAmt={passedAmount}
                />
              )
            ) : section === "delivery" ? (
              <Products />
            ) : (
              <div>Something went wrong</div>
            )
          ) : (
            <div style={{ height: "50vh" }}>
              <Loader />
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default Silvify;
